import {
    ALL_CRICKET_MARKETS,
    FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25, FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35,
    UNDER_OVER,
} from '../constants/marketTypes';


export function getMarketsByCode(marketCode, markets) {
    let marketsByCode = [];

    if (marketCode && markets && markets.length) {
        for (const element of markets) {

            if (marketCode.code === UNDER_OVER.code && (element.id.substring(0, 3) === FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05.code || element.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15.code || element.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25.code || element.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35.code)) {
                marketsByCode.push(element);
            }
            // check if there are markets for the given code
            if (element.id.substring(0, marketCode.code.length) === marketCode.code) {
                marketsByCode.push(element);
            }
        }
        if (marketCode.code === UNDER_OVER.code && marketsByCode.length) {
            let marketsCodeAux = marketsByCode.filter((mks) => mks.id.substring(0, 3) === FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05.code);
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15.code));
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25.code));
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 3) === FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35.code));
            marketsByCode = marketsCodeAux;
        }
    }
    return marketsByCode;
}

export function getMarketByCode(code) {
    return ALL_CRICKET_MARKETS.filter(market => market.code === code.toString())[0];
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/helpers/marketHelpers.js